import { useContext, useCallback } from "react";
import { AppContext } from "../Contexts/AppContextProvider";
import PatientDetails from "./PatientInformation";
import SaveAndNavigate from "./SaveAndNavigate";
import SideBarMenu from "./SideBarMenu";

const PageLayout = ({ children }) => {
  const { isSideMenuActive, setIsSideMenuActive, appState, savePageRef } =
    useContext(AppContext);

  const { activePageId, navigatePaths, customCssClass } =
    appState.pageConfig || {};

  const handleSave = useCallback((validate) => {
    return savePageRef?.current?.(validate);
  }, []);

  const toggleNav = useCallback(() => {
    setIsSideMenuActive(!isSideMenuActive);
  }, [isSideMenuActive]);

  const hasSaveHandler = typeof savePageRef?.current === "function";

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          {hasSaveHandler && navigatePaths && (
            <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
              <SaveAndNavigate paths={navigatePaths} Save={handleSave} />
            </div>
          )}
        </div>
      </section>

      <section className="main-survey-section">
        <SideBarMenu activePageId={activePageId} />

        <button
          className={isSideMenuActive ? "openbtn" : "openbtn active"}
          onClick={toggleNav}
        >
          <i
            id="arrowNavigation"
            className="fa fa-arrow-left"
            aria-hidden="true"
          />
        </button>

        <div
          className={`col-pad-left ${customCssClass || ""}`}
          id="main"
          style={{
            marginLeft: isSideMenuActive ? "350px" : "0",
          }}
        >
          {children}
        </div>
      </section>
    </>
  );
};

export default PageLayout;
